import { Fragment, useState } from 'react';

import { InfoCircleIcon } from '@zola/zola-ui/src/components/SvgIconsV3/InfoCircle';
import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';
import useEffectOnce from '@zola/zola-ui/src/hooks/useEffectOnce';
import P from '@zola/zola-ui/src/typography/Paragraphs';

import ReactTooltip from 'react-tooltip';

import styles from './featuredVendorsToolTip.module.less';

export const FeaturedVendorsToolTip = () => {
  const { isDesktopDevice } = useResponsiveDesign();

  // ReactTooltip seems to render as a block causing CLS if its rendered on the server
  const [showTip, setShowTip] = useState(false);
  useEffectOnce(() => setShowTip(true));

  const tooltipTrigger = {
    'data-tip': true,
    'data-for': 'featured-vendors-sort-info',
  };
  const desktopTooltipTrigger = isDesktopDevice ? tooltipTrigger : {};
  const mobileTooltipTrigger = !isDesktopDevice ? { ...tooltipTrigger, 'data-event': 'click' } : {};

  return (
    <Fragment>
      <P.BodySmall className={styles.sortInfo} color="BLACK_075" {...mobileTooltipTrigger}>
        How do we sort results, including Sponsored Ads?
        <InfoCircleIcon
          className={styles.sortInfoIcon}
          width={18}
          height={18}
          title=""
          showTitle={false}
          {...desktopTooltipTrigger}
        />
      </P.BodySmall>
      {showTip && (
        <ReactTooltip
          id="featured-vendors-sort-info"
          place={!isDesktopDevice ? 'top' : 'right'}
          effect="solid"
          globalEventOff={!isDesktopDevice ? 'click' : ''}
        >
          <P.BodySmall className={styles.sortInfoTooltip} color="WHITE_100">
            Results are sorted based on vendor details like participation in our paid advertising
            program, distance from your preferred locations, and relevance to your search and
            filters.
          </P.BodySmall>
        </ReactTooltip>
      )}
    </Fragment>
  );
};
